import React, { useContext, useEffect, useState } from 'react'
import { Icon } from 'semantic-ui-react'
import { ParentContext } from '../../../cnr/contexts/ParentContext'
import { uniqueKey } from '../../../common/keys'

const _icons = {
  all: 'users',
  direct: 'user circle'
}

const PdfIcon = ({ itemPdf, showFile, _keyy }) => {

  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {}
  const { storage_state } = states ?? {}

  const [itemPdfUrl, setItemPdfUrl] = useState()

  // storageContext 
  const {
    appStorageUrlFiles,
  } = storage_state ?? {}

  const { pdf: global_pdf } = appStorageUrlFiles ?? {}

  useEffect(
    () => {
      if (global_pdf && global_pdf[itemPdf] && global_pdf[itemPdf].urls && global_pdf[itemPdf].urls.full) {
        setItemPdfUrl(global_pdf[itemPdf].urls.full)
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [global_pdf, itemPdf]
  )

  const openAppUrl = () => { window.open(itemPdfUrl, '_blank') }
  // 

  const handlePdfIconClick = (e) => {
    e && e.stopPropagation()
    openAppUrl()
  }

  return <div
    className={'icon-ind'} key={uniqueKey('cs', 'dl', _keyy)}
    onClick={(e) => handlePdfIconClick(e)}>
    <Icon name={'file pdf'} color={'blue'} inverted circular size='small' />
  </div>
}

export default PdfIcon
